import { RegisterPage } from '#/views/register'
import { getLayout, LayoutWithoutSideMenu } from '#/widgets/layouts'

RegisterPage.getLayout = getLayout(LayoutWithoutSideMenu, { titlePage: 'Регистрация' })

export default RegisterPage
